import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/companies")({
  component: CompaniesLayout,
})

function CompaniesLayout() {
  return <Outlet />
}
